import React from 'react'

import './ScrollingLoader.scss'

const ScrollingLoader: React.FC<{ scale?: number }> = ({ scale = 1 }) => {
  return (
    <div
      className="ScrollingLoader"
      style={{ transform: `scale(${scale})`, transformOrigin: 'center' }}
    >
      <div className="ScrollingLoader__balls">
        <div className="ScrollingLoader__ball ScrollingLoader__ball-first" />
        <div className="ScrollingLoader__ball ScrollingLoader__ball-second" />
        <div className="ScrollingLoader__ball ScrollingLoader__ball-third" />
      </div>
    </div>
  )
}

export default ScrollingLoader
